import React from 'react';
import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import GameDetailsPage from "./components/GameDetailsPage";
import Game from "./components/Game";

function App() {


    return (

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Game />} />
          <Route path="/games/:id" element={<GameDetailsPage />} />
        </Routes>

      </BrowserRouter>
  );
}

export default App;
